import React from 'react';
import { Navigate } from 'react-router-dom';

const PlayerProtectedRoute = ({ children }) => {
  const adminInfo = JSON.parse(localStorage.getItem('adminInfo') || '{}');
  if (adminInfo?.token) {
    return <Navigate to="/dashboard" replace />;
  }

  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const resolvedToken =
    userInfo?.token ||
    localStorage.getItem('token') ||
    localStorage.getItem('userToken');
  const hasUserId = Boolean(userInfo?.id || userInfo?._id);

  if (hasUserId && resolvedToken) {
    return children;
  }

  return <Navigate to="/player-login" replace />;
};

export default PlayerProtectedRoute;
